import { render, staticRenderFns } from "./StepFinish.vue?vue&type=template&id=c5c2dd76&scoped=true&"
import script from "./StepFinish.vue?vue&type=script&lang=js&"
export * from "./StepFinish.vue?vue&type=script&lang=js&"
import style0 from "./StepFinish.vue?vue&type=style&index=0&id=c5c2dd76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c2dd76",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ValidationContainer: require('/workspace/components/Validation/ValidationContainer.vue').default})
